export const SET_RATING_INFO = "SET_RATING_INFO";